import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'react-grid-gallery';
import '../styles/Gallery.css';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const texts = {
    section: {
      en: 'Gallery',
      fr: 'Galerie',
    },
    block1: {
      title: {
        en: ['Our', 'Gallery'],
        fr: ['Notre', 'Galerie'],
      },
    }
  }

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const setSection =(section, props, inView)=>{
    if(inView && props.nav !== section){
        setTimeout(()=>{
            props.setNav(section);
          }, 500);
    }
  }

const PhotoGallery =(props)=> {
    const section = "gallery";
    const lang = props.lang;
    const { ref, inView } = useInView({threshold: 0.2});
    useEffect(() => {
        setSection(section, props, inView);
    });
    return (
    <section ref={ref} id="gallery" className="gallery section">
      <div className="container">

        <div className="section-title" >
          <h2 className={animate(inView, 'bounceInDown', 0.2)}>{texts.section[lang]}</h2>
          <h3 className={animate(inView, 'flipInX', 1)}>{texts.block1.title[lang][0]} <span>{texts.block1.title[lang][1]}</span></h3>
        </div>

        <div className={animate(inView, 'fadeIn', 0, 'slow')}>
            <Gallery
                images={props.images}
                lightboxWidth={1536}
                backdropClosesModal={true}
                showLightboxThumbnails={true}
                enableImageSelection={false}
            />
        </div>
      </div>
    </section>
  );
}

PhotoGallery.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            srcset: PropTypes.array,
            caption: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            thumbnailWidth: PropTypes.number.isRequired,
            thumbnailHeight: PropTypes.number.isRequired,
            isSelected: PropTypes.bool
        })
    ).isRequired
};

const getImages = () => {
    return [
        {
            src: "../gallery/millorit-1.jpg",
            thumbnail: "../gallery/millorit-1-thumb.jpg",
            thumbnailWidth: 231,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-2.jpg",
            thumbnail: "../gallery/millorit-2-thumb.jpg",
            thumbnailWidth: 132,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-3.jpg",
            thumbnail: "../gallery/millorit-3-thumb.jpg",
            thumbnailWidth: 135,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-4.jpg",
            thumbnail: "../gallery/millorit-4-thumb.jpg",
            thumbnailWidth: 221,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-5.jpg",
            thumbnail: "../gallery/millorit-5-thumb.jpg",
            thumbnailWidth: 135,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-6.jpg",
            thumbnail: "../gallery/millorit-6-thumb.jpg",
            thumbnailWidth: 167,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-7.jpg",
            thumbnail: "../gallery/millorit-7-thumb.jpg",
            thumbnailWidth: 257,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-8.jpg",
            thumbnail: "../gallery/millorit-8-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-9.jpg",
            thumbnail: "../gallery/millorit-9-thumb.jpg",
            thumbnailWidth: 249,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-10.jpg",
            thumbnail: "../gallery/millorit-10-thumb.jpg",
            thumbnailWidth: 345,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-11.jpg",
            thumbnail: "../gallery/millorit-11-thumb.jpg",
            thumbnailWidth: 272,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-12.jpg",
            thumbnail: "../gallery/millorit-12-thumb.jpg",
            thumbnailWidth: 318,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-13.jpg",
            thumbnail: "../gallery/millorit-13-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-14.jpg",
            thumbnail: "../gallery/millorit-14-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-15.jpg",
            thumbnail: "../gallery/millorit-15-thumb.jpg",
            thumbnailWidth: 256,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-16.jpg",
            thumbnail: "../gallery/millorit-16-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-17.jpg",
            thumbnail: "../gallery/millorit-17-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-18.jpg",
            thumbnail: "../gallery/millorit-18-thumb.jpg",
            thumbnailWidth: 299,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-19.jpg",
            thumbnail: "../gallery/millorit-19-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-20.jpg",
            thumbnail: "../gallery/millorit-20-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-21.jpg",
            thumbnail: "../gallery/millorit-21-thumb.jpg",
            thumbnailWidth: 265,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-22.jpg",
            thumbnail: "../gallery/millorit-22-thumb.jpg",
            thumbnailWidth: 274,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-23.jpg",
            thumbnail: "../gallery/millorit-23-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-24.jpg",
            thumbnail: "../gallery/millorit-24-thumb.jpg",
            thumbnailWidth: 279,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-25.jpg",
            thumbnail: "../gallery/millorit-25-thumb.jpg",
            thumbnailWidth: 305,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-26.jpg",
            thumbnail: "../gallery/millorit-26-thumb.jpg",
            thumbnailWidth: 260,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-27.jpg",
            thumbnail: "../gallery/millorit-27-thumb.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-28.jpg",
            thumbnail: "../gallery/millorit-28-thumb.jpg",
            thumbnailWidth: 255,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-29.jpg",
            thumbnail: "../gallery/millorit-29-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-30.jpg",
            thumbnail: "../gallery/millorit-30-thumb.jpg",
            thumbnailWidth: 265,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-31.jpg",
            thumbnail: "../gallery/millorit-31-thumb.jpg",
            thumbnailWidth: 233,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-32.jpg",
            thumbnail: "../gallery/millorit-32-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-33.jpg",
            thumbnail: "../gallery/millorit-33-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-34.jpg",
            thumbnail: "../gallery/millorit-34-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-35.jpg",
            thumbnail: "../gallery/millorit-35-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-36.jpg",
            thumbnail: "../gallery/millorit-36-thumb.jpg",
            thumbnailWidth: 133,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-37.jpg",
            thumbnail: "../gallery/millorit-37-thumb.jpg",
            thumbnailWidth: 290,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-38.jpg",
            thumbnail: "../gallery/millorit-38-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-39.jpg",
            thumbnail: "../gallery/millorit-39-thumb.jpg",
            thumbnailWidth: 283,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-40.jpg",
            thumbnail: "../gallery/millorit-40-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-41.jpg",
            thumbnail: "../gallery/millorit-41-thumb.jpg",
            thumbnailWidth: 279,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-42.jpg",
            thumbnail: "../gallery/millorit-42-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-43.jpg",
            thumbnail: "../gallery/millorit-43-thumb.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-44.jpg",
            thumbnail: "../gallery/millorit-44-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-45.jpg",
            thumbnail: "../gallery/millorit-45-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-46.jpg",
            thumbnail: "../gallery/millorit-46-thumb.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-47.jpg",
            thumbnail: "../gallery/millorit-47-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-48.jpg",
            thumbnail: "../gallery/millorit-48-thumb.jpg",
            thumbnailWidth: 165,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
        {
            src: "../gallery/millorit-49.jpg",
            thumbnail: "../gallery/millorit-49-thumb.jpg",
            thumbnailWidth: 270,
            thumbnailHeight: 180,
            caption: "Chateaux La Croix de Millorit"
        },
    ]
}

PhotoGallery.defaultProps = {
    images: getImages()
};

export default PhotoGallery